<template>
  <operator-form
    :operator="operator"
    :entities-by-id="entitiesById"
    :permissions-by-group="permissionsByGroup"
    :roles-by-id="rolesById"
    :is-loading="isLoading"
    :can-edit-transaction-limits="canEditTransactionLimits"
    :can-edit-payout-limits="canEditPayoutLimits"
    :manual-transaction-expenditure-by-period="manualTransactionExpenditureByPeriod"
    :transaction-limits="userLimits"
    :is-loading-limits="isLoadingLimits"
    :is-loading-payout-stats="isLoadingPayoutStats"
    :expenditure-by-type="expenditureByType"
    :payout-stats="payoutStats"
    :readonly="readonly"
    @close="$emit('close')"
    @save="$emit('save', $event)"
    @save-limit="onSaveLimit"
    @delete-limit="onDeleteLimit"
  />
</template>

<script>
import { API } from '@/utils/api'
import { OperatorForm } from '../components'
const USER_EXPENDITURE = '/$v/account/finance/expenditure_by_period.json'
const USER_LIMITS = '/$v/manual_transaction_limits/list.json'
const UPDATE_LIMIT = '/$v/manual_transaction_limits/update.json'
const DELETE_LIMIT = '/$v/manual_transaction_limits/delete.json'

export default {
  props: {
    operator: {
      type: Object,
      default: () => ({})
    },
    entitiesById: {
      type: Object,
      default: () => ({})
    },
    rolesById: {
      type: Object,
      default: () => ({})
    },
    permissionsByGroup: {
      type: Object,
      default: () => ({})
    },
    canEditTransactionLimits: Boolean,
    canEditPayoutLimits: Boolean,
    readonly: Boolean,
    isLoading: Boolean,
  },

  components: {
    OperatorForm
  },

  data() {
    return {
      isLoadingLimits: false,
      isLoadingPayoutStats: false,
      manualTransactionExpenditureByPeriod: {
        current_day_amount: 0,
        current_week_amount: 0,
        current_month_amount: 0
      },
      payoutStats: {
        today: 0,
        last_week: 0,
        last_month: 0,
      },
      userLimits: [],
      expenditureByType: {}
    }
  },

  mounted() {
    if (this.canEditTransactionLimits && this.operator.user_id) {
      this.loadManualTransactionData()
    }
    if (this.canEditPayoutLimits && this.operator.user_id) {
      this.loadPayoutStats()
    }
  },
  methods: {
    onSaveLimit(transactionLimit) {
      this.isLoadingLimits = true
      return API.call(UPDATE_LIMIT, { transactionLimit: {
        ...transactionLimit,
        user_id: this.operator.user_id
      }}).then(this.loadManualTransactionData)
    },

    async onDeleteLimit(id) {
      const confirmation = await this.$root.$confirm('Confirm', `Delete limit #${id} ?`)

      if (confirmation) {
        this.isLoadingLimits = true
        return API.call(DELETE_LIMIT, { id }).then(this.loadManualTransactionData)
      }
    },

    loadLimits() {
      return API.call(USER_LIMITS, {
        user_id: this.operator.user_id
      }).then(r => this.userLimits = r.data)
    },

    loadExpenditures(limits) {
      return Promise.all(limits.map(limit => API.call(USER_EXPENDITURE, {
        userId: this.operator.user_id,
        type: limit.type
      }))).then(r => this.expenditureByType = limits.reduce((acc, currentValue, index) => (acc[currentValue.type] = r[index].data, acc), {}))
    },

    loadManualTransactionData() {
      this.isLoadingLimits = true
      this.loadLimits().then(this.loadExpenditures).finally(() => {
        this.isLoadingLimits = false
      })
    },

    loadPayoutStats() {
      this.isLoadingPayoutStats = true
      return API.call('/users/payout_stats.json', {
        user_id: this.operator.user_id,
      }).then(r => this.payoutStats = r.data)
        .finally(() => {
          this.isLoadingPayoutStats = false
        })
    },
  }
}
</script>
